<template>
    <section>
        <div class="d-flex flex-row flex-wrap justify-content-lg-between justify-content-center">
            <!--<div class="align-self-end mr-lg-auto order-1 order-lg-0 p-1 p-lg-0 mb-2">
                    <button
                        v-if="showFirstLastButtons"
                        class="btn first-page btn-primary"
                        @click="onClickFirstPage()"
                        :class="{ disabled: isInFirstPage }"
                    >
                        {{ firstButtonText }}
                    </button>
                </div>-->
            <div class="align-self-center order-0 order-lg-1 col-lg-12 text-center">
                <div class="no-gutters">
                    <div class="item-number-listing text-center">
                        <small>{{ firstItem }} – {{ lastItem }} {{ outOfText }} {{ total }}</small>
                    </div>
                </div>
                <nav>
                    <ul class="automation-pagination pagination">
                        <li v-if="isInFirstPage" class="disabled">
                            <img class="lazyload" alt="Arrow Left" data-src="https://objects.kaxmedia.com/auto/o/139739/e8ccc9ff9a.svg"/>
                        </li>
                        <li v-else>
                            <img class="lazyload" @click="onClickPreviousPage" alt="Arrow Left"
                                data-src="https://objects.kaxmedia.com/auto/o/139702/da48137e63.svg"/>
                            <!--<img alt="Arrow Left" src="https://objects.kaxmedia.com/auto/o/139739/e8ccc9ff9a.svg"/>-->
                            <!--<span class="p-2" @click="onClickPreviousPage" :disabled="isInFirstPage">&laquo;</span>-->
                        </li>

                        <li
                            v-for="page in pages"
                            class=""
                            :key="page.label + Math.random()"
                            :class="{
                                active: isPageActive(page.label),
                                disabled: (typeof page.label === 'string' || page.label instanceof String),
                                'd-none': page.class === 'hideMobile',
                                'd-lg-inline-block': page.class === 'hideMobile',
                                'd-lg-none': page.class === 'showMobileOnly',
                                'd-inline-block': page.class === 'showMobileOnly'}"
                        >
                            <span
                                @click="onClickPage(page.label)"
                                :disabled="isPageActive(page.label) || (typeof page.label === 'string' || page.label instanceof String)"
                                :class="{ active: isPageActive(page.label) }"
                            >{{ page.label }}</span>
                        </li>

                        <li v-if="isInLastPage" class="disabled">
                            <img class="lazyload" alt="Arrow Right" data-src="https://objects.kaxmedia.com/auto/o/139740/eb6a54de44.svg"/>
                        </li>
                        <li v-else class="">
                            <img class="lazyload" @click="onClickNextPage" alt="Arrow Right"
                                data-src="https://objects.kaxmedia.com/auto/o/139703/8a8d4cc06f.svg"/>
                            <!--<img alt="Arrow Right" src="https://objects.kaxmedia.com/auto/o/139740/eb6a54de44.svg"/>-->
                            <!--<span class="p-2" @click="onClickNextPage" :disabled="isInLastPage">&raquo;</span>-->
                        </li>
                    </ul>
                </nav>
            </div>
            <!-- <div class="align-self-end ml-lg-auto order-2 order-lg-2 p-1 p-lg-0 mb-2">
                    <button
                        v-if="showFirstLastButtons"
                        class="btn last-page btn-primary"
                        @click="onClickLastPage()"
                        :class="{ disabled: isInLastPage }"
                    >
                        {{ lastButtonText }}
                    </button>
                </div>-->
        </div>
    </section>
</template>

<script>
export default {
    name: 'pagination',
    props: {
        maxVisibleButtons: {
            type: Number,
            required: false,
            default: 5,
        },
        totalPages: {
            type: Number,
            required: true,
        },
        total: {
            type: Number,
            required: true,
        },
        perPage: {
            type: Number,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        },
        showFirstLastButtons: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        firstItem() {
            return (this.currentPage - 1) * this.perPage + 1;
        },
        lastItem() {
            if (this.isInLastPage) {
                return this.total;
            }

            return this.firstItem + this.perPage - 1;
        },
        startPage() {
            if (this.currentPage === 1) {
                return 1;
            }

            if (this.currentPage === this.totalPages && this.totalPages >= this.maxVisibleButtons) {
                return this.totalPages - this.maxVisibleButtons + 1;
            }

            return this.currentPage - 1;
        },
        endPage() {
            return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        },
        pages() {
            return this.fetchLinksWithClasses(this.currentPage, this.totalPages);
        },
        isInFirstPage() {
            return this.currentPage === 1;
        },
        isInLastPage() {
            return this.currentPage === this.totalPages;
        },
        firstButtonText() {
            return window.translations.pagination.first || 'First';
        },
        lastButtonText() {
            return window.translations.pagination.last || 'Last';
        },
        outOfText() {
            return window.translations.pagination.out_of || 'out of';
        },
    },
    methods: {
        onClickFirstPage() {
            this.$emit('pagechanged', 1);
        },
        onClickPreviousPage() {
            this.$emit('pagechanged', this.currentPage - 1);
        },
        onClickPage(page) {
            if (typeof page === 'string' || page instanceof String) {
                return;
            }
            this.$emit('pagechanged', page);
        },
        onClickNextPage() {
            this.$emit('pagechanged', this.currentPage + 1);
        },
        onClickLastPage() {
            this.$emit('pagechanged', this.totalPages);
        },
        isPageActive(page) {
            return this.currentPage === page;
        },
        /**
         * This function is coming from App\Support\PaginationHelpers that also has a test file
         * Fetch the pagination button links
         * This will return the array like [1, 2, 3, 4, 5] or [1, 2, 3, '...', 7]
         * We always want maximum of 5 links
         * @return array
         * @param currentPage
         * @param totalPages
         */
        fetchLinks(currentPage = 1, totalPages = 1) {
            let links = [];
            if (totalPages <= 5) {
                for (let i = 1; i <= totalPages; i += 1) {
                    links.push(i);
                }
                return links;
            }

            // setup array [1,2,3,4,5];
            for (let i = 1; i <= 5; i += 1) {
                links.push(i);
            }

            let firstPage = 1;
            for (let pageIndex = 1; pageIndex <= links.length; pageIndex++) {
                switch (pageIndex) {
                    case 1:
                        break;
                    case 2:
                        // if current is `close (less than 2 away) ` to the first page - we want to add the 1,2,3
                        if (currentPage - 2 === firstPage) {
                            links[1] = currentPage - 1;
                        } // current page is lower or equal to our default - so just add 2
                        else if (currentPage === 1 || currentPage === 2) {
                            links[1] = 2;
                        } // current page is to `far` so we will add the dots
                        else {
                            links[1] = '...';
                        }
                        break;
                    case 3:
                        // if we are at the end - we want to add the last 3 numbers - 18,19,20 as last 3 buttons
                        if (currentPage === totalPages) {
                            links[2] = currentPage - 2;
                        } // if current is just 1 number before the last page - update this one to that number
                        else if (currentPage === (totalPages - 1)) {
                            links[2] = currentPage - 1;
                        } // if current page is bigger than 2 or less than 2 from last number - update this middle page
                        else if (currentPage > (firstPage + 1) && currentPage < (totalPages - 1)) {
                            if (currentPage - 2 > firstPage) {
                                links[2] = currentPage;
                            } else if (currentPage + 2 < totalPages) {
                                links[2] = currentPage;
                            }
                        }
                        break;
                    case 4:
                        // if we are at the end - we want to add the last 3 numbers - 18,19,20 as last 3 buttons
                        if (currentPage === totalPages) {
                            links[3] = currentPage - 1;
                        } // if current is just 1 number before the last page - update this one to that number
                        else if (currentPage + 1 === totalPages) {
                            links[3] = currentPage;
                        } else if (currentPage + 2 === totalPages) {
                            links[3] = currentPage + 1;
                        } else {
                            links[3] = '...';
                        }
                        break;
                    case 5:
                        // always update this to the total pages (last page to go to)
                        links[4] = totalPages;
                        break;
                }
            }

            return links;
        },
        /**
         * This function is coming from App\Support\PaginationHelpers that also has a test file
         * Fetch the pagination button links
         * @return array
         * @param currentPage
         * @param totalPages
         */
        fetchLinksWithClasses(currentPage = 1, totalPages = 1) {
            let links = this.fetchLinks(currentPage, totalPages);

            let linksWithClasses = [];
            for (let i = 0; i < links.length; i++) {
                linksWithClasses.push({'class': '', 'label': links[i]});
            }

            // if not 5 items or if middle item is disabled - return as it is
            if (linksWithClasses.length < 5 || links[2] === '...' || (currentPage === totalPages)) {
                return linksWithClasses;
            }

            // we want to add 2 links before current and 2 after current ONLY for desktop
            let classes = 'hideMobile';

            // if links count === 5
            // if the link in middle is not ...
            // if link 2 or link 4 is ...
            // if current is in the middle
            // if current - 2 > first - allow prepend
            // if current + 2 < last - allow prepend

            let allowPrepend = ((currentPage - 2) > links[0]) && links[1] === '...';
            let allowAppend = ((currentPage + 2) < links[4]) && (links[3] === '...') && (currentPage >= 3);
            //        dump("Current: {currentPage} || Allow Prepend: {allowPrepend} ||  " . "Allow Append: {allowAppend}");

            if (allowPrepend) {
                let replacePrepend = true;
                let prependOne = currentPage - 2;
                let prependTwo = currentPage - 1;

                // do we need to replace the second link (...) or leave it
                // this means there are more `links` so we only add these two links after the ...
                if (currentPage - 3 > links[0]) {
                    replacePrepend = false;
                }

                if (replacePrepend && links[1] === '...') {
                    linksWithClasses[1]['class'] = 'showMobileOnly';
                }

                let prependItem1 = {'class': classes, 'label': prependOne};
                let prependItem2 = {'class': classes, 'label': prependTwo};

                // if second last page is selected - we only want to prepend 1 item
                if (currentPage + 1 === totalPages) {
                    linksWithClasses.splice(2, 0, prependItem1);
                } else {
                    linksWithClasses.splice(2, 0, prependItem1, prependItem2);
                }
            }

            if (allowAppend) {
                let replaceAppend = true;
                let appendOne = currentPage + 1;
                let appendTwo = currentPage + 2;

                // do we need to replace the 4th link (...) or leave it
                // this means there are more `links` so we only add these two links after the current page
                if (currentPage + 3 < links[4]) {
                    replaceAppend = false;
                }

                let replaceIndex = 3;
                if (linksWithClasses.length === 6) {
                    replaceIndex = 4;
                } else if (linksWithClasses.length === 7) {
                    replaceIndex = 5;
                } else if (linksWithClasses.length === 8) {
                    replaceIndex = 6;
                }

                if (replaceAppend && links[3] === '...') {
                    let lastDisabledSeparatorIndex = linksWithClasses.length - 2;
                    linksWithClasses[lastDisabledSeparatorIndex]['class'] = 'showMobileOnly';
                }

                let appendItem1 = {'class': classes, 'label': appendOne};
                let appendItem2 = {'class': classes, 'label': appendTwo};
                linksWithClasses.splice(replaceIndex, 0, appendItem1, appendItem2);
            }

            return linksWithClasses;
        },
    },
};
</script>

<style lang="scss" scoped>
.go-to-first,
.go-to-last {
    margin: 5.6px 0 8.5px 0;

    button {
        margin-bottom: 7px;
    }
}
</style>
